<template>
  <div class="main-content infoantrian">
    <!-- <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Info Antrian</h2>
            </div>
          </div>
        </div>
      </div>
    </section>-->
    <section class="fasilitas-containter">
      <div class="container">
        <!-- <div class="section-title text-center">
		      	<div class="row">
		        	<div class="col-md-12">
		          		<h2 class="text-uppercase mt-0 line-height-1">Info Monitoring Antrian <span class="text-theme-colored">Rumah Sakit UII</span></h2>
		        	</div>
		      	</div>
        </div>-->
        <iframe
          :src="jadwalUrl"
          frameborder="0"
          border="0"
          cellspacing="0"
          style="border-style: none; width: 100%; min-height: 700px; max-height: 700px;"
        ></iframe>
        <div class="section-content mt-30" style="display: none;">
          <div class="row">
            <div class="col-md-6 mb-15">
              <div class="row">
                <div class="col">
                  <select class="custom-select doctor-select">
                    <option selected>Pilih Poliklinik</option>
                    <option value="1">Anak</option>
                    <option value="2">Obstetri & Ginekologi</option>
                    <option value="3">Saraf</option>
                    <option value="4">Penyakit Dalam</option>
                    <option value="5">Bedah</option>
                    <option value="6">Patologi Anatomi</option>
                    <option value="7">Patologi Klinik</option>
                    <option value="8">Anestesi</option>
                    <option value="9">Gigi & Mulut</option>
                    <option value="10">Penyakit Kulit & Kelamin</option>
                    <option value="11">Paru</option>
                    <option value="12">Akupuntur</option>
                    <option value="13">Urologi</option>
                    <option value="14">Orthopedi</option>
                    <option value="15">Jiwa/Psikiatri</option>
                    <option value="16">THT</option>
                    <option value="17">Radiologi</option>
                    <option value="18">Jantung</option>
                    <option value="19">Psikolog</option>
                  </select>
                </div>
                <div class="col">
                  <select class="custom-select doctor-select">
                    <option selected>Pilih Dokter</option>
                    <option value="1">dr. Ade Indrisari Sp.A</option>
                    <option value="2">dr. Agung Triono Sp. A(K)</option>
                    <option value="3">dr. Marie Caesarini SpOG, MPH</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30">
                  <div class="p-20 bg-uii-antrian">
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <h4 class="mt-15 mb-10">Total Antrian</h4>
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <h1 class="mt-15 mb-10 antrian-text">30</h1>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30">
                  <div class="p-20 bg-uii-antrian new">
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <h4 class="mt-15 mb-10">Antrian Saat Ini</h4>
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <h1 class="mt-5 mb-5 antrian-text">012</h1>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="p-20 bg-uii-antrian">
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <h4 class="mt-15 mb-10">Antrian Selanjutnya</h4>
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <h1 class="mt-15 mb-10 antrian-text">013</h1>
                        <h1 class="mt-15 mb-10 antrian-text">014</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30">
                  <div class="p-20 bg-uii-antrian">
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <h4 class="mt-15 mb-10">Antrian Dilewati</h4>
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <h1 class="mt-15 mb-10 antrian-text">009</h1>
                        <h1 class="mt-15 mb-10 antrian-text">008</h1>
                        <h1 class="mt-15 mb-10 antrian-text">003</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30">
                  <div class="p-20 bg-uii-antrian">
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <h4 class="mt-15 mb-10">Antrian Selesai</h4>
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <h1 class="mt-15 mb-10 antrian-text">011</h1>
                        <h1 class="mt-15 mb-10 antrian-text">010</h1>
                        <h1 class="mt-15 mb-10 antrian-text">007</h1>
                        <h1 class="mt-15 mb-10 antrian-text">006</h1>
                        <h1 class="mt-15 mb-10 antrian-text">005</h1>
                        <h1 class="mt-15 mb-10 antrian-text">004</h1>
                        <h1 class="mt-15 mb-10 antrian-text">002</h1>
                        <h1 class="mt-15 mb-10 antrian-text">001</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { TERRA_ANTRIAN } from "../config/VariableComponents";
export default {
  data() {
    return {
      jadwalUrl: TERRA_ANTRIAN,
    };
  },
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// src/pages/InfoAntrian.vue